import React from 'react';
import { twMerge } from '@/utils';

interface BaseProps {
  alt: string;
  ariaHidden?: boolean;
  className?: string;
  src: string;
  tabIndex?: number;
}

type LinkProps =
  | { to?: undefined, toText?: never }
  | { to: string, toText: string };

type CardImageProps = BaseProps & LinkProps;

const CardImage = ({ alt, ariaHidden = false, className = '', src, tabIndex = -1, to, toText }: CardImageProps) => {
  const base = (
    <img
      alt={alt}
      aria-hidden={ariaHidden}
      className={twMerge('tw-min-w-full tw-h-[150px] tw-object-cover', className)}
      src={src}
      tabIndex={tabIndex}
    />
  );

  if (to) {
    return (
      <a aria-hidden={ariaHidden} href={to} tabIndex={tabIndex}>
        {base}<span className="sr-only">{toText}</span>
      </a>
    );
  }

  return base;
};

export default CardImage;
